/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FaceScanStrictHttpResponse } from '../../face-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanSessionRequestModel } from '../../models/scan-session-request-model';
import { SessionResponseModel } from '../../models/session-response-model';

export interface ScanRequestSessionPost$Params {
  
    /**
     * The scan session request model containing profile information
     */
    body?: ScanSessionRequestModel
}

export function scanRequestSessionPost(http: HttpClient, rootUrl: string, params?: ScanRequestSessionPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SessionResponseModel>> {
  const rb = new RequestBuilder(rootUrl, scanRequestSessionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as FaceScanStrictHttpResponse<SessionResponseModel>;
    })
  );
}

scanRequestSessionPost.PATH = '/Scan/RequestSession';
